import { Checkbox, FormControlLabel, Paper } from "@mui/material";
import { ExtraConfigsCalibrationSubform } from "../../ExtraConfigsCalibrationSubform";
import { GpsOffsetCalibrationSubform } from "../../GpsOffsetCalibrationSubform";
import { SteeringValveCalibrationSubform } from "../../SteeringValveCalibrationSubform";
import { StepProps } from "./StepProps";
import { TractorViewModel } from "../TractorViewModel";
import { typedPath } from "typed-path";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

const S = typedPath<TractorViewModel>();

export const CalibrationStep: FC<StepProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<TractorViewModel>();

  return (
    <div className="flex flex-col gap-2">
      <Paper className="flex flex-col gap-4 p-4">
        <FormControlLabel
          label={t(
            "views.autotractor.equipment.tractors.storeCalibrationDataForTractor"
          )}
          checked={values.calibration.present}
          disabled={disabled}
          control={<Checkbox />}
          onChange={() =>
            setFieldValue("calibrationPresent", !values.calibration.present)
          }
        />
      </Paper>
      <GpsOffsetCalibrationSubform
        basePath={S.calibration.value}
        readOnly={disabled || !values.calibration.present}
      />
      <SteeringValveCalibrationSubform
        basePath={S.calibration.value}
        readOnly={disabled || !values.calibration.present}
      />
      <ExtraConfigsCalibrationSubform
        basePath={S.calibration.value}
        driveType={values.archetype?.driveType}
        values={values.calibration.value}
        readOnly={disabled || !values.calibration.present}
      />
    </div>
  );
};
